import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/Constants";

export const getLibraryByUserId = async (id,fetchPredefined) => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/library/user/${id}/${fetchPredefined}`);               
        return response.data;
    } catch (error) {
        console.error('Error fetching Libraries by userId :', error);
        return error.response.data;
        //throw error;
    }
};

export const addLibrary = async (payload) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/library`, payload);
    return response.data;
  } catch (error) {
    const code = error.response?.data?.code;
    if (code === 'LIBRARY_NAME_EXISTS') {
      throw { code: 'LIBRARY_NAME_EXISTS' };
    }
    console.error('Error adding library entry:', error);
    return error.response.data;
    //throw error;
  }
};

export const updateLibrary = async (payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/library`, payload);
    return response.data;
  } catch (error) {
    const code = error.response?.data?.code;
    if (code === 'LIBRARY_NAME_EXISTS') {
      throw { code: 'LIBRARY_NAME_EXISTS' };
    }
    return error.response.data;
    //throw error;
  }
};